import {detect} from 'detect-browser';
import Component from '../abstracts/Component';

export default class StickyComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-sticky-component="true"]'
    };
  }

  constructor() {
    super();
  }

  initSticky(stickyBits) {
    const stickyElelements = document.querySelectorAll(this.SELECTORS.main);
    const browser = detect();

    stickyElelements.forEach(el => {
      const dataset = el.dataset;
      const maxRes = dataset.stickyActiveOnMax ? dataset.stickyActiveOnMax : null;
      const minRes = dataset.stickyActiveOnMin ? dataset.stickyActiveOnMin : null;

      if (browser && browser.name === 'ie') el.style.width = `${el.clientWidth}px`;

      if ((!maxRes && !minRes) || this.$matchMedia(maxRes, minRes)) {
        stickyBits(el, dataset);
      }

    });


  }

  // testStickySupport() {
  //   const prefix = ['', '-o-', '-webkit-', '-moz-', '-ms-'];
  //   for (let i = 0; i < prefix.length; i += 1) {
  //     document.head.style.position = `${prefix[i]}sticky`;
  //   }
  //   document.head.style.position = '';
  //   return !!test.position
  // }

  importLibrary() {
    this.moduleLoader.loadStickyAndExecute(
      (module) => {
        this.initSticky(module.default);
      },
      (error) => {
        console.log("failed to load slick ", error.stack);
      }
    );
  }


  render() {
    if (document.querySelectorAll(this.SELECTORS.main)) this.importLibrary();
  }
}
